import React from 'react';
import './AvatarGroup.scss';

export const AVATAR_LIMIT = 5;
function AvatarGroup({
    pictures,
}: {
    pictures: string[];
}): React.ReactElement | null {
    const shown = pictures.slice(0, AVATAR_LIMIT);
    if (!shown.length) return null;
    return (
        <div className="rd-avatars" aria-hidden="true">
            {shown.map((src, index) => (
                <span
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${src}-${index}`}
                    className="rd-avatars__item"
                    style={{ backgroundImage: `url(${src})` }}
                />
            ))}
        </div>
    );
}

export default React.memo(AvatarGroup);
